import { useEffect } from "react";
import { useSelector } from "react-redux";
import makeStyles from "@mui/styles/makeStyles";

import { SECTION_MANAGEMENT } from "../../consts/routes.js";

import { useDepotMap } from "../../hooks/useDepotMap.js";

import { selectedSectionSelector } from "../../reducers/ownApp/selectors.js";
import {
  isRemovingSectionSelector,
  sectionEditModeSelector,
} from "../../reducers/sectionManagement/selectors.js";

import { Layers } from "../../components/Layers/Layers.jsx";
import { Sources } from "../../components/Sources.jsx";
import { LoadingBackdrop } from "../../components/LoadingBackdrop.jsx";
import Header from "../../components/Header/index.jsx";
import { Subheader } from "../../components/Subheaders/SectionManagement/index.jsx";
import { View } from "../../components/View.jsx";
import { AppSections } from "../../components/LeftMenu/index.jsx";
import Mapbox from "../../components/Mapbox.js";
import { SectionManagementModal } from "../../components/Modals/SectionManagementModal/SectionManagementModal.jsx";
import { AddSectionModal } from "../../components/Modals/AddSection/AddSectionModal.jsx";
import { getFitBounds } from "../../reducers/map/selectors.js";

const useStyles = makeStyles({
  appContainer: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    maxWidth: "100vw",
    maxHeight: "100vh",
  },
  content: {
    flexGrow: 1,
    position: "relative",
    display: "flex",
    overflow: "hidden",
    height: "calc(100% - 70px)",
  },
  left: {
    display: "flex",
  },
  right: {
    flexGrow: 1,
    position: "relative",
    display: "flex",
    flexDirection: "column",
  },
  mapContainer: {
    flexGrow: 1,
  },
  modalContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
});

const SectionManagement = () => {
  const styles = useStyles();
  const fitBounds = useSelector(getFitBounds);
  const selectedSection = useSelector(selectedSectionSelector);
  const sectionEditMode = useSelector(sectionEditModeSelector);
  const isRemovingSection = useSelector(isRemovingSectionSelector);

  useEffect(() => {
    document.title = "Section - Quantum Management";
  }, []);

  const { map, handleOnLoad } = useDepotMap();

  return (
    <View className={styles.appContainer}>
      <LoadingBackdrop />

      <Header>
        <Subheader />
      </Header>

      <View className={styles.content}>
        <View className={styles.left}>
          <AppSections />
        </View>

        <View className={styles.right}>
          <View className={styles.mapContainer}>
            <Mapbox
              application={SECTION_MANAGEMENT}
              fitBounds={fitBounds}
              handleOnLoad={handleOnLoad}
            >
              <Sources map={map} />
              <Layers map={map} />
            </Mapbox>
          </View>

          {!isRemovingSection && (selectedSection || sectionEditMode) && (
            <View className={styles.modalContainer}>
              <SectionManagementModal />
            </View>
          )}
        </View>
        <AddSectionModal />
      </View>
    </View>
  );
};

export default SectionManagement;
